import { useMemo } from 'react';
import { useUserCustomAclQuery } from '../../../graphql/graphql';
import { useAclContext } from '../Components/AclContextProvider';
import useScope from '../../Scope/Hooks/useScope';

export default function useCustomAclForPatient(patientId: string) {
	const { data } = useUserCustomAclQuery({ id: patientId });
	const { isSlovakia } = useScope();
	const { isAllowed } = useAclContext();

	const isLaboratoryRequestsAllowed: boolean = useMemo(() => {
		return true;
		let allowed: boolean = isAllowed('laboratory_requests');

		//IF IS SLOVAKIA AND PATIENT DONT HAVE VŠZP INSURANCE COMPANY -> DISABLE LABORATORY REQUEST
		if (
			isSlovakia &&
			data?.user?.profile?.insuranceCompanyTermItem?.value !== '25'
		) {
			allowed = false;
		}

		return allowed;
	}, [data, isSlovakia, isAllowed]);

	return {
		isLaboratoryRequestsAllowed,
	};
}
